'use strict';

var React = require('react');
var cs = require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
require('../../Button-e2bdd95d.js');
var components_Button_utils_getRootBtnClasses = require('./utils/getRootBtnClasses.js');
require('../Icon/Icon.js');
require('../../icons/LoaderOutline.js');
require('../Spinner/Spinner.js');
var components_Button_components_buttonContent_index = require('./components/buttonContent/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

const Button = React.forwardRef(({ isBlock = false, size = "normal", variant = "primary", type = "button", hideLabel = false, ...props }, ref) => {
    const { className, label, icon, iconRight, showSpinner, ...otherProps } = props;
    const rootClasses = cs__default['default'](components_Button_utils_getRootBtnClasses.getRootClasses({ variant, size, isBlock, ...props }), className);
    return (React__default['default'].createElement("button", Object.assign({ ref: ref, className: rootClasses }, otherProps),
        React__default['default'].createElement(components_Button_components_buttonContent_index, Object.assign({ isBlock: isBlock, hideLabel: hideLabel, type: type, size: size, variant: variant }, props))));
});

module.exports = Button;
